import React, { Component, Fragment } from 'react';

export default class ErrorList extends Component {
    render() {
        const { errors = [], canContinue, hide } = this.props;
        if (hide) {
            return null;
        }

        // eventually remove duplicates
        const uniqueErrors = [...new Set(errors)];
        return (
            <Fragment>
                <ul className={'form__errors'}>
                    {uniqueErrors.map((error, i) => {
                        if (error.includes('Error : ')) {
                            const filteredError = error.substr(8).trim();
                            return (
                                <li key={i} className={'danger'}>
                                    {`Error : ${window.VULOG_TRANSLATE(filteredError)}`}
                                </li>
                            );
                        }
                        return (
                            <li key={i} className={'danger'}>
                                {window.VULOG_TRANSLATE(error)}
                            </li>
                        );
                    })}
                </ul>
                {uniqueErrors && uniqueErrors.length > 0 && canContinue && (
                    <p>{window.VULOG_TRANSLATE('CONTINUE_REGISTRATION')}</p>
                )}
            </Fragment>
        );
    }
}
